import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { Observable, Subject, combineLatest } from 'rxjs';
import Swal from "sweetalert2";
import { switchMap, takeUntil } from 'rxjs/operators';
import { Pagination } from "src/app/infraestructure/interfaces/pagination/pagination.DTO";
import { ParametersDTO } from "src/app/infraestructure/interfaces/parameters/ParametersDTO";
import { Solicitud } from "src/app/infraestructure/interfaces/referente/SolicitudDTO";
import { SolicitudPasajeroDTO } from "src/app/infraestructure/interfaces/referente/SolicitudPasajeroDTO";
import { SolicitudRecorridosDTO } from "src/app/infraestructure/interfaces/referente/SolicitudRecorridosDTO";
import { ParametricListsService } from "src/app/infraestructure/services/parametric-lists/parametric-lists.service";
import { ReferentApiService } from "src/app/infraestructure/services/referent/referent-api.service";
import { PaginationI } from 'src/app/infraestructure/models/pagination.interface';
import { SolicitudesPendientesAprobacionDTO } from "src/app/infraestructure/interfaces/referente/SolicitudPendienteAprobacionDTO";
import { ConsultaSolicitudesDisponiblesDTO } from "src/app/infraestructure/interfaces/referente/ConsultaSolicitudesDisponiblesDTO";
import { AppState, UserLogin } from "ngx-sds-login";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: "app-solicitud-servicio",
  templateUrl: "./solicitud-servicio.component.html",
  styleUrls: ["./solicitud-servicio.component.scss"],
})
export class SolicitudServicioComponent implements OnInit {

  @ViewChild('reqRoute', { static: true }) reqRoute: any;

  @Output() SolicitudEvent = new EventEmitter<any>();
  @Output() actionsButtons = new EventEmitter<boolean>();
  @Output() codeSolicitud = new EventEmitter<number>();
  @Output() solicitudSeleccionadaEmit = new EventEmitter<SolicitudesPendientesAprobacionDTO>();
  @Output() cancelSolicitudDisponible = new EventEmitter<boolean>();
  @Output() solicitudDisponibleSeleccionada = new EventEmitter<ConsultaSolicitudesDisponiblesDTO>();
  @Output() solicitudUpdate = new EventEmitter<Solicitud>();

  @Input() title!: string;
  @Input() submitted: number = 0;
  @Input() $views: number = 0;
  @Input() reloadTable!: boolean;
  @Input() solicitudId: number = 0;
  @Input() solicitudGestion: Solicitud = new Solicitud();

  $parametricList: ParametersDTO = new ParametersDTO();
  solicitudRecorrido: SolicitudRecorridosDTO = new SolicitudRecorridosDTO();
  solicitud: Solicitud = new Solicitud();
  solicitudPasajeros: SolicitudPasajeroDTO = new SolicitudPasajeroDTO();
  solicitudesPendientesAprobacion: SolicitudesPendientesAprobacionDTO[] = [];
  consultaSolicitudesDisponibles: ConsultaSolicitudesDisponiblesDTO[] = [];
  user$: Observable<UserLogin>;

  today: any = new Date();
  actualDate: any = this.today.toJSON().slice(0, 10);

  paginationRequest: Pagination = new Pagination();
  paginationResponse = {} as PaginationI;
  userId: number = 0;
  rolId: number = 0;
  fileTmp = {} as {file: File, fileName: string};

  private $topSubcription = new Subject<void>();

  constructor(
    private _listSrv: ParametricListsService,
    private referentApiSrv: ReferentApiService,
    private store: Store<AppState>,
    private router: Router,
    config: NgbModalConfig,
    private modalService: NgbModal,
  ) { 
    this.user$ = this.store.select(state => state.user);

    config.backdrop = 'static';
    config.keyboard = false;
    config.size = 'xl';
  }

  ngOnInit(): void {
    this.user$.pipe(
      takeUntil(this.$topSubcription),
      switchMap(user => {
        if (user.id > 0) {
          this.userId = user.id;
          this.rolId = user.rolId;
        }
  
        return combineLatest(
          this._listSrv.getDataLists('TIP_TRANSPORTE'),
          this._listSrv.getDataLists('TIP_SERVICIOS'),
          this._listSrv.getDataLists('TIP_CANTIDAD_PASAJEROS'),
          this._listSrv.getDataLists('TIP_DEPENDENCIAS'),
          this._listSrv.getDataLists('TIP_DIRECTIVOS')
        );
      })
    )
    .subscribe(([
      Data1, Data2, Data3, Data4, Data5,
    ]: any) => {
      if (Data1.code == 200) this.$parametricList.typeTransportList = Data1.data;
      if (Data2.code == 200) this.$parametricList.typeServicesList = Data2.data;
      if (Data3.code == 200) this.$parametricList.typeQuantPassList = Data3.data;
      if (Data4.code == 200) this.$parametricList.typeDependenciesList = Data4.data;
      if (Data5.code == 200) this.$parametricList.typeManagersList = Data5.data;
      if(this.solicitud.recorridos.length == 0){
        this.solicitud.recorridos.push(new SolicitudRecorridosDTO());
      }
      
      if (this.$views === 2 || this.$views === 5) {
        this.paginationRequest.itemsPorPagina = 5;
        this.paginationRequest.numeroPagina = 1;
        this.getSolicitudes(this.paginationRequest);
      }
    });
  }
  
  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['submitted'] && this.submitted > 0) {
      this.saveRequestService();
    }

    if (changes['reloadTable'] && this.reloadTable === true) {
      const currentUrl = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
      this.getSolicitudes(this.paginationRequest);
      this.validateCheck(false);
    }

    if (changes['solicitudId'] && this.solicitudId > 0) {
      this.getSolicitudById(this.solicitudId);
    }

    if (changes['solicitudGestion'] && this.solicitudGestion.id) {
      this.solicitud = this.solicitudGestion;
    }
  }

  getSolicitudes(paginationReq: Pagination) {
    paginationReq.rolId = this.rolId;
    if (this.$views === 2) {
      this.referentApiSrv.postSolicitudConsultaAprDir(paginationReq)
        .pipe(takeUntil(this.$topSubcription))
        .subscribe(res => {
          if (res.code === 200) {
            this.paginationResponse = {
              itemsPage: res.data.itemsPage,
              page: res.data.number,
              pages: res.data.pages
            }
            this.paginationRequest.itemsPorPagina = res.data.itemsPage;
            this.paginationRequest.numeroPagina = res.data.number;

            this.solicitudesPendientesAprobacion = res.data.data;
          }
        });
    } else if (this.$views === 5) {
      this.referentApiSrv.postSolicitudConsultaBanRef(paginationReq)
        .pipe(takeUntil(this.$topSubcription))
        .subscribe(res => {
          if (res.code === 200) {
            this.paginationResponse = {
              itemsPage: res.data.itemsPage,
              page: res.data.number,
              pages: res.data.pages
            }
            this.paginationRequest.itemsPorPagina = res.data.itemsPage;
            this.paginationRequest.numeroPagina = res.data.number;

            this.consultaSolicitudesDisponibles = res.data.data;
          }
        });
    }
  }

  enableRoutePlus() {
    this.solicitud.recorridos.push(new SolicitudRecorridosDTO());
  }

  disabledRoutePlus(index: number) {
    this.solicitud.recorridos.splice(index + 1, 1);
  }

  validDeliveryDate() {
    const day = new Date(this.solicitud.dtFechaPrestacionServicio).getDay(); // Obtiene el dia para saber si es fin de semana
    const friday = new Date(this.solicitud.dtFechaPrestacionServicio.split('-'));
    friday.setDate(friday.getDate() - (friday.getDay() + 2) % 7) // Obtiene elultimo viernes de la fecha selecccionada
    friday.setHours(friday.getHours() + 12); // Se agregan 12 horas para la validacion

    if (day > 4) {
      if (this.today > friday) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "<h5 style='color:#f8bb86'>" + 'Advertencia' + "</h5>",
          text: `Recuerde, la solicitud de servicios para el fin de semana sólo se podra radicar antes del mediodía del día viernes`,
          showConfirmButton: true,
          confirmButtonColor: "#2BA3BF",
          confirmButtonText: "Aceptar",
        });

        this.solicitud.dtFechaPrestacionServicio = null;
      }
    }
  }


  saveRequestService(): any {
    if (this.solicitud.pasajeros.length < 1 && this.reqRoute.form.valid !== false) {
      this.reqRoute.form.status = "INVALID";
      this.solicitudPasajeros.bEsResponsableServicio = null;
    }

    if (!this.reqRoute.form.valid) return Swal.fire({
      position: "center",
      icon: "warning",
      title: "<h5 style='color:#f8bb86'>" + 'Advertencia' + "</h5>",
      text: `Debe completarse el diligenciamiento de todos los campos para registrar la solicitud de servicio`,
      showConfirmButton: true,
      confirmButtonColor: "#2BA3BF",
      confirmButtonText: "Aceptar",
    });

    if (this.$views === 8 && this.fileTmp.file == undefined) return Swal.fire({
      position: "center",
      icon: "warning",
      title: "<h5 style='color:#f8bb86'>" + 'Advertencia' + "</h5>",
      text: `Debe cargar el soporte para registrar la solicitud de servicio extemporanea`,
      showConfirmButton: true,
      confirmButtonColor: "#2BA3BF",
      confirmButtonText: "Aceptar",
    });



    let formData = new FormData();
    formData.append('TxArchivoAdjunto', this.fileTmp.file || null);
    formData.append('DtFechaPrestacionServicio', this.solicitud.dtFechaPrestacionServicio);
    formData.append('TipoTransporteId', this.solicitud.tipoTransporteId);
    formData.append('ICantidadPasajeros', this.solicitud.iCantidadPasajeros);
    formData.append('TipoServicioId', this.solicitud.tipoServicioId);
    formData.append('TxJustificacion', this.solicitud.txJustificacion);
    formData.append('DependenciaId', this.solicitud.dependenciaId);
    formData.append('DirectorJefeDependenciaId', this.solicitud.directorJefeDependenciaId);
    formData.append('UsuarioId', String(this.userId));
    formData.append('BSolicitudAjustada', this.solicitud.bSolicitudAjustada || false);
    formData.append('Pasajeros', JSON.stringify(this.solicitud.pasajeros));
    formData.append('Recorridos', JSON.stringify(this.solicitud.recorridos));


    this.SolicitudEvent.emit(formData);
  }

  /** ================================================================================================================================ */

  getFile(event: any) {
    const file: FileList = event.target.files;
    let fil : File = file[0];

    if (file != null) {
      this.fileTmp = {
        file: fil,
        fileName: fil.name
      }
    }
  }

  /** ================================================================================================================================ */

  getSolicitudById(id: number) {
    if (!id) return;
    this.referentApiSrv.getSolicitudById(id)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          this.solicitud = res.data;
          //console.log("solucitud por id", this.solicitud);
          this.solicitud.recorridos = res.data.recorridos.filter(x=> x.id != null);
          //console.log("solicitud por id 2", this.solicitud);
          this.codeSolicitud.emit(res.data.id);
        }
        if (this.solicitud.motivoCancelacionId !== null) this.getParametroMotivoCancelacion();
      });
  }

  validateCheck(value: boolean) {
    if (!value) this.solicitud = new Solicitud();

    this.actionsButtons.emit(value);
  }

  responsableSeleccionado(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;
    //poner en false todas
    this.solicitud.pasajeros.forEach(el => el.bEsResponsableServicio = false);
    //poner en true la seleccionada
    let esBD = this.solicitud.pasajeros.find(el => el.id > 0);
    let seleccionado = null;
    if(esBD){
      seleccionado = this.solicitud.pasajeros.find(el => el.id == selectedValue);
    }else{
      seleccionado = this.solicitud.pasajeros[Number(selectedValue)];
    }
    if(seleccionado) seleccionado.bEsResponsableServicio = true;
  }

  getParametroMotivoCancelacion() {
    this._listSrv.getDataLists('TIP_MOTIVOS_CANCELACION')
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code == 200) this.$parametricList.typeCancellationsList = res.data;
      });
  }

  emitCodeSolicitud(id: number) {
    this.codeSolicitud.emit(id);
  }

  getSolicitudSeleccionada(solicitud: SolicitudesPendientesAprobacionDTO) {
    this.solicitudSeleccionadaEmit.emit(solicitud);
  }

  getSolicitudDisponibleSeleccionada(solicitud: ConsultaSolicitudesDisponiblesDTO) {
    this.solicitudDisponibleSeleccionada.emit(solicitud);
  }

  updateSolicitudDisponible() {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "<h5 style='color:#f8bb86'>" + 'Advertencia' + "</h5>",
      text: `Esta seguro de actualizar los registros de la solicitud de servicio seleccionada`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "#2BA3BF",
      confirmButtonText: "ACEPTAR",
      cancelButtonText: "CANCELAR"
    }).then(confirm => {
      if (confirm.isConfirmed) this.solicitudUpdate.emit(this.solicitud);
    });
  }

  addNovedad(novedad: any) {
    if (novedad === 'close') return this.modalService.dismissAll(novedad);

    this.modalService.open(novedad);
  }

  seleccionarPasajeros(){ //Este es mi nuevo metodo
    let tipoTransporte = this.$parametricList.typeTransportList.find(s=>s.idParametroDetalle == this.solicitud.tipoTransporteId);

    if (tipoTransporte && tipoTransporte.vcCodigoInterno === 'TIP_TRANSPORTE_CARGA') {
      this._listSrv.getDataLists('TIP_CANTIDAD_PASAJEROS')
      .subscribe(res => {
        if (res.code == 200) this.$parametricList.typeQuantPassList = res.data.filter((p: any) => Number(p.txDescripcion) <= 2);
      });
    } else {
      this._listSrv.getDataLists('TIP_CANTIDAD_PASAJEROS')
      .subscribe(res => {
        if (res.code == 200) this.$parametricList.typeQuantPassList = res.data;
      });
    }
  }

  getPasajeroResponsable(): any {
    return this.solicitud.pasajeros.find(p => p.bEsResponsableServicio === true);
  }
  
}
